module.exports = __webpack_public_path__ + "img/vir1.ab6edd91.png";